import script from "./image-message.vue?vue&type=script&lang=ts&setup=true"
export * from "./image-message.vue?vue&type=script&lang=ts&setup=true"

import "./image-message.vue?vue&type=style&index=0&id=24ad87dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ad87dc"]])

export default __exports__